import { ReactElement } from 'react';
import { DrawerPanel } from '@dmc/ui';
import useLoadModelData from '@casops/components/layout/model-form/useLoadModelData';
import { useGetSafetyAlertQuery } from '@casops/store/apis/personnelSafetyApi';
import { SafetyAlertHeader } from './components/header/SafetyAlertHeader';
import { Permission, useIsUserWithPermission } from '@casops/permissions';
import SafetyAlertManagerView from './manager-view/SafetyAlertManagerView';
import SafetyAlertViewerView from './viewer-view/SafetyAlertViewerView';

export function SafetyAlertPanel(): ReactElement {
  const { isLoaded: isItemLoaded, item } = useLoadModelData({
    useModelQueryHook: useGetSafetyAlertQuery,
  });

  const isSafetyManger = useIsUserWithPermission(Permission.SafetyManagement);

  if (isItemLoaded && item) {
    if (isSafetyManger) {
      return <SafetyAlertManagerView item={item} />;
    } else {
      return <SafetyAlertViewerView item={item} />;
    }
  } else {
    return (
      <DrawerPanel isLoaded={false} header={<SafetyAlertHeader model={undefined} />}></DrawerPanel>
    );
  }
}

export default SafetyAlertPanel;
